<div class="container">
    <mat-dialog-title class="title-block">
        <h2>ADD PARTNER</h2>
        <app-close-x-icon (click)="onClose()"></app-close-x-icon>
    </mat-dialog-title>
    <mat-dialog-content class="content-block">

        <div class="partner-input-form">
            <mat-form-field class="partner-form-field">
                <mat-label>PARTNER NAME</mat-label>
                <input class="partner-input-field" matInput placeholder="Enter Partner Name"
                    [(ngModel)]="newPartnerName">
            </mat-form-field>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="action-block">
        <button class="add-partner-btn" mat-button (click)="addNewPartner()">ADD PARTNER</button>
        <button class="cancel-btn" mat-button (click)="onClose()">CANCEL</button>
    </mat-dialog-actions>
</div>